import { Button, ButtonType, EpicIcons } from "@constellation-academy/epic-ui";
import { useFormik } from "formik";
import { Dialog } from "primereact/dialog";
import { Suspense, useState } from "react";
import * as Yup from "yup";
import { useTranslation } from "@i18n/hooks";
import {
	type SelectDiscountCodeFieldDialogProps,
	type SelectDiscountCodeFieldDialogState,
} from "./select-discount-code-field-dialog.interface";
import { ValidatedField } from "../../../components/ValidatedField";
import { SelectDiscountCodeField } from "../select-discount-code-field";
import { type DiscountCode } from "../select-discount-code-field/select-discount-code-field.interface";

export const SelectDiscountCodeFieldDialog = ({
	updateField,
	fieldValue: selectedDiscountCode,
	onChange,
	disabled,
}: SelectDiscountCodeFieldDialogProps) => {
	const { t } = useTranslation("common");
	const [isModalOpen, setModalOpen] = useState<boolean>(false);

	const formik = useFormik<SelectDiscountCodeFieldDialogState>({
		initialValues: {
			discountCode: selectedDiscountCode,
		},
		validationSchema: Yup.object().shape({}),
		onSubmit: (values) => {
			updateField({
				code: values.discountCode?.code,
			});
			setModalOpen(false);
			onChange?.();
		},
	});

	const handleDialogOnHide = () => {
		setModalOpen(false);
	};

	const handleSelectProductOnClick = () => {
		setModalOpen(true);
	};

	return (
		<>
			<div className="flex w-auto align-items-center">
				<Button
					type={ButtonType.Button}
					disabled={disabled}
					onClick={handleSelectProductOnClick}
					label={t("discountCode.selectDiscountCode")}
				/>
			</div>
			<Dialog
				header={t("discountCode.selectDiscountCode")}
				onHide={handleDialogOnHide}
				className="w-10"
				visible={isModalOpen}
			>
				<Suspense fallback={<div>{t("discountCode.loading")}</div>}>
					<form onSubmit={formik.handleSubmit}>
						<ValidatedField<SelectDiscountCodeFieldDialogState, DiscountCode>
							className="mb-4"
							name={"discountCode"}
							label={t("discountCode.selectOneDiscountCode")}
							formikConfig={{
								...formik,
								errors: { ...formik.errors, discountCode: undefined },
							}}
							component={SelectDiscountCodeField}
						/>
						<Button
							type={ButtonType.Submit}
							icon={EpicIcons.CHECK}
							label={t("actions.select")}
						/>
					</form>
				</Suspense>
			</Dialog>
		</>
	);
};
